<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-select ref="field"
                  v-model="inputValue"
                  :clearable="clearable"
                  :filter="filter"
                  autofocus-filter
                  :filter-placeholder="`${$T('type to search')} (${itemsAvailable})`"
                  :name="path"
                  :float-label="label | capitalize"
                  :options="computedOptions"
                  :color="color"
                  :disable="form.busy || disable"
                  @termsChanged="onTermsChanged"
                  @input="onInput">
        </q-select>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import axios from 'axios'
    import {debounce, QSelect, QSpinner} from 'quasar-framework'

    // Add a watcher to QSelect component on "created" event. This watcher emits a "termsChanged" event when
    // the internal var "terms" changes allowing us to hook on that event and sync our local "terms" var
    QSelect.created = function () {
        this.$watch('terms', (newVal) => {
            this.$emit('termsChanged', newVal)
        })
    }

    export default {
        name: 'VAutocomplete',

        mixins,

        props: {
            resourcePath: {
                type: String,
                required: true
            },
            map: {
                type: Function,
                default: (item) => ({label: item.title, value: item.id})
            },
            top: {
                type: Number,
                default: 5
            },
            perPage: {
                type: Number,
                default: 5
            },
            itemPlural: String,
        },

        components: {
            QSelect,
            QSpinner
        },

        data() {
            return {
                isLoading: false,
                terms: '',
                serverData: {
                    data: [],
                    meta: {}
                },
                topOptions: []
            }
        },

        watch: {
            terms: 'update'
        },

        mounted() {
            this.update()
        },

        computed: {
            computedOptions() {
                var options = []
                if (this.isLoading)
                    options = [{value: '#', label: `${this.$T('loading')}...`, disable: true}]
                else if (!this.terms)
                    options = [{value: '#', label: this.$T('frequent/recent options:'), disable: true}]
                        .concat(this.topOptions)
                else
                    options = [{value: '#', label: this.itemsAvailable, sublabel: this.needsNarrow, disable: true}]
                        .concat(this.serverData.data)
                return this.addSelectedTo(options)
            },

            searchResults() {
                return `${
                    this.serverData.meta ? this.serverData.meta.total : this.$t('not_available')
                    } ${this.niceItems}`
            },

            needsNarrow() {
                if (this.serverData.meta.total > this.perPage)
                    return this.$_T('showing :per_page. narrow it changing your search.', this.serverData.meta)
                if (this.serverData.meta.total == 0)
                    return this.$_T('no results for :terms.', {terms: this.terms})
            },

            itemsAvailable() {
                return `${
                    this.serverData.meta ? this.serverData.meta.total_unfiltered : this.$t('not_available')
                    } ${this.niceItems} ${this.$t('available_plural')}`
            },

            niceItems() {
                return this.itemPlural ? this.itemPlural : this.$t('items')
            }
        },

        methods: {
            filter: () => true,

            update() {
                if (!this.terms && this.topOptions.length > 0) return

                this.isLoading = true
                let query = {
                    search: this.terms,
                    per_page: this.perPage
                }
                axios.get(`${config.appUrl}/api/${this.resourcePath}`, {params: query})
                    .then(response => {
                        this.isLoading = false
                        let results = response.data
                        results.data = results.data.map(this.map)
                        if (results.data && results.data.length == 1) {
                            this.inputValue = results.data[0].value
                            this.onInput()
                            this.$refs.field.hide()
                        }
                        if (results.data) {
                            if (this.topOptions.length == 0)
                                this.topOptions = results.data.slice(0, this.top)

                            results.data = this.addSelectedTo(results.data)
                            this.serverData = results
                            this.$nextTick(() => this.$refs.field.reposition())
                        }
                    })
                    .catch(() => {
                        this.isLoading = false
                    })
            },

            addSelectedTo(options) {
                if (!options.find(opt => opt.value == this.value) && this.value)
                    return [this.serverData.data.find(opt => opt.value == this.value)].concat(options)
                return options
            },

            onTermsChanged: debounce(function (terms) {
                this.terms = terms
            }, 300)
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VAutocomplete.vue